<div id="faceLivenessReactContainer" *ngIf="start_liveness_session">
    <app-faceliveness-react-wrapper #faceliveness [sessionId]="session_id"
        (livenessResults)="handleLivenessAnalysisResults($event)"
        (livenessErrors)="handleErrors($event)"
        ></app-faceliveness-react-wrapper>
</div>

<div *ngIf="liveness_session_complete">
    <mat-grid-list cols="1" rowHeight='10vh'>
        <mat-grid-tile><mat-grid-tile-header>Resultado da validação : {{face_live_message}} <mat-icon *ngIf="is_live" class='icon-display-success'>thumb_up</mat-icon> <mat-icon *ngIf="!is_live" class='icon-display-failure'>thumb_down</mat-icon></mat-grid-tile-header></mat-grid-tile>
    </mat-grid-list>
    <button class="amplify-button--primary .submit-button amplify-button amplify-field-group__control amplify-button--primary" (click)="get_liveness_session()">Re Test</button>
</div>